module.exports = __webpack_public_path__ + "img/career_support_logo_white.b69734f8.svg";